// extracted by mini-css-extract-plugin
export default {"button":"ll-z","reviewSort":"ml-z"};